export enum Permission {
  AddAddress = 1,
  AddContact = 5,
  ViewAddressList = 105,
  ViewPersonList = 106,
}
